// Constant data for Seller::Inbound::Pickup

export const MIN_QUANTITY = 15

export const SCHEDULED = {
  YES : 'true',
  NO  : 'false'
}

export const COURIER = {
  PCP_EXPRESS: 'pcp_express'
}

export const PICKUP_VEHICLE_TYPES = {
  CAR: {
    label : 'mobil',
    value : 'car'
  },
  BIKE: {
    label : 'motor',
    value : 'bike'
  },
  NOT_APPLICABLE: {
    label : 'tidak dapat diterapkan',
    value : 'not_applicable'
  }
}